import { Activity } from "./Activity";

export class Recorder
{
    Activity : Activity | null = null;
    Timer: NodeJS.Timer | null = null;
    get IsStarted(): boolean { return this.Activity != null };
    IsPaused: boolean = false;

    onActivityChanged: (activity: Activity) => void = () => {};
    
    Values: {
        HR: number | null,
        Power: number | null,
        Cadence: number | null,
    } = { HR: null,  Power: null, Cadence: null }
    
    startRecordingNewActivity()
    {
        this.Activity = new Activity(new Date());
        //console.log("startNewActivity");
        this.startRecording();
    }
    
    startRecording() 
    {
        if (this.Activity == null)
            this.startRecordingNewActivity();

        this.IsPaused = false;
        this.Timer = setInterval(this.TimerTick.bind(this), 1000);
        //console.log(this.Timer);
        this.TimerTick();
    }
    
    stopRecording() 
    {
        if (this.Timer != null)
            clearInterval(this.Timer);
    }
    
    stopRecordingActivity()
    {
        this.stopRecording();
        this.Activity = null;
    }

    togglePauseRecording() 
    {
        this.IsPaused = !this.IsPaused;
        if (this.IsPaused)
        {
            this.Activity?.EndInterval();
        }
        else
        {
            this.TimerTick();
        }
    }

    private TimerTick()
    {
        if (this.Activity == null || this.IsPaused)
            return;
    
        //console.log("tick");
        const now = new Date();
        let time: number;
        time = now.valueOf() - this.Activity.StartTime.valueOf();
    
        this.Activity.Record(now, 0, 0, 0, this.Values.HR, this.Values.Power, this.Values.Cadence);
        this.onActivityChanged(this.Activity);
    }
}